import React from "react";

/**
 * Without this, any throw during render unmounts the whole tree and the user
 * sees a blank page with no clue what failed — in a production build React
 * prints no component stack unless a boundary catches the error. The
 * componentStack logged here is what names the offending component.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(
      "[ErrorBoundary] crashed at",
      window.location.pathname,
      "\nerror:",
      error,
      "\ncomponentStack:",
      info && info.componentStack
    );
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{ padding: "60px 24px", textAlign: "center", fontFamily: "inherit" }}>
        <p style={{ fontSize: 15, color: "#111827", marginBottom: 8 }}>
          Something went wrong on this page.
        </p>
        <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 20 }}>
          {String((error && error.message) || error)}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "8px 18px",
            fontSize: 13,
            color: "#ffffff",
            background: "#3953fb",
            border: "none",
            borderRadius: 8,
            cursor: "pointer"
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
